import { Injectable } from '@angular/core';
import localeNl from '@angular/common/locales/nl';
import { registerLocaleData } from '@angular/common';
import moment from 'moment';
import 'moment/locale/nl';

export type Locale = 'nl';
type AngularLocaleType = unknown;

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  private currentLocale: Locale = 'nl';
  private readonly supportedLocales: Record<Locale, AngularLocaleType> = {
    nl: localeNl,
  };

  constructor() {
    this.setLocale('nl');
  }

  setLocale(locale: Locale) {
    this.currentLocale = locale;
    registerLocaleData(this.supportedLocales[this.currentLocale]);
    // moment formats dates/times through its global locale
    moment.locale(locale);
  }

  getLocale(): Locale {
    return this.currentLocale;
  }
}
